import { Module } from 'wrapper6'

export default class Modal extends Module {
  ready () {
    this.OPEN_TRIGGERS = document.querySelectorAll('[data-mtt-modal]')
    this.CLOSE_TRIGGERS = document.querySelectorAll('.mtt-modal__close')
    this.OPEN_CLASS = 'mtt-modal-wrap--open'

    if (this.OPEN_TRIGGERS.length) {
      this.addTriggerEventListeners()
      this.addCloseEventListener()
    }
  }

  addTriggerEventListeners () {
    for (let i = 0; i < this.OPEN_TRIGGERS.length; i++) {
      const TRIGGER = this.OPEN_TRIGGERS[i]
      const ID = TRIGGER.getAttribute('data-mtt-modal')
      const MODAL = this.getModalFromID(ID)

      TRIGGER.addEventListener('click', event => {
        event.preventDefault()
        MODAL.classList.add(this.OPEN_CLASS)
      })
    }
  }

  addCloseEventListener () {
    for (let i = 0; i < this.CLOSE_TRIGGERS.length; i++) {
      const TRIGGER = this.CLOSE_TRIGGERS[i]
      const ID = TRIGGER.getAttribute('data-mtt-modal-id')
      const MODAL = this.getModalFromID(ID)

      TRIGGER.addEventListener('click', event => {
        event.preventDefault()
        MODAL.classList.remove(this.OPEN_CLASS)
      })
    }
  }

  getModalFromID (id) {
    return document.querySelector(`.mtt-modal-wrap[data-mtt-modal-id="${id}"]`)
  }
}
